import axios from "axios";
import store from "../store";
import { Toast } from "vant";
import config from "./config";
import Vue from "vue";
// http_ui_data = {
//   no_loading: false,
//   no_need_toast: false
// }
let baseJumpUrl = config.baseJumpUrl;
let no_close_loding = false;
axios.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json; charset=utf-8";

    // 请求前加入当前终端
    config.headers["platform"] = "H5";
    //     // 请求前加入Token
    config.headers["Access-Token"] = sessionStorage.getItem("ad_member_token");

    // //用于判断从安卓端app进入，并添加请求头
    let AntDevice = sessionStorage.getItem("AntDevice");
    // console.log(AntDevice, 'AntDevice');
    if (AntDevice) {
      config.headers["Ant-Device"] = AntDevice;
    }
    // loading
    if (!config.http_ui_data.no_loading) {
      Vue.prototype.$wx_loading.add();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    //Toast.clear();
    if (response.headers.Authorization || response.headers.authorization) {
      let authorization =
        response.headers.authorization || response.headers.Authorization;
      // 正常用户
      sessionStorage.setItem(
        "ad_member_token",
        authorization.replace("Bearer ", "")
      );
    }

    if (!no_close_loding) {
      Vue.prototype.$wx_loading.remove();
    }
    return response;
  },
  (error) => {
    //Toast.clear();
    if (!no_close_loding) {
      Vue.prototype.$wx_loading.remove();
    }
    return Promise.resolve(error.response);
  }
);
function no_close_loding_fn(bol) {
  no_close_loding = bol;
}
function checkStatus(response, http_ui_data) {
  // 如果http状态码正常，则直接返回数据
  if (response && response.status === 200) {
    if (response.data.status !== 200 && !http_ui_data.no_need_toast) {
      Toast(response.data.message);
    }
    return response;
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: "网络异常",
  };
}

function checkCode(res) {
  return res;
}

export default {
  all(arr) {
    no_close_loding_fn(true);
    return axios.all(arr).then(
      axios.spread(() => {
        no_close_loding_fn(false);
        store.dispatch("setLoadingStatus", false);
      })
    );
  },
  post(url, data, http_ui_data = {}) {
    return axios({
      method: "post",
      baseURL: http_ui_data.new_url || baseJumpUrl,
      url,
      http_ui_data,
      data: data,
      timeout: 60000,
    })
      .then((response) => {
        return checkStatus(response, http_ui_data);
      })
      .then((res) => {
        return checkCode(res);
      });
  },
  get(url, params, http_ui_data = {}) {
    return axios({
      method: "get",
      baseURL: http_ui_data.new_url || baseJumpUrl,
      url,
      params, // get 请求时带的参数
      http_ui_data,
      timeout: 60000,
    })
      .then((response) => {
        // 仪式感
        return checkStatus(response, http_ui_data);
      })
      .then((res) => {
        return checkCode(res);
      });
  },
};
